import moment from "moment"
import _includes from "lodash/includes"

export const buildDownloadParams = (protocol) => {
  const startDate = moment().subtract(6, "months").format("DD/MM/YYYY")
  const endDate = moment().format("DD/MM/YYYY")

  return {
    startDate,
    endDate,
    protocol: { keys: [protocol] }
  }
}

export const buildSendMailParams = (email, customer, protocol) => {
  const startDate = moment().subtract(6, "months").format("DD/MM/YYYY")
  const endDate = moment().format("DD/MM/YYYY")

  const objEmail = {
    emails: [email.email]
  }

  return {
    email: objEmail.emails[0],
    keys: [protocol],
    startDate,
    endDate,
    customerSegment: customer.customerSegment,
    customerName: customer.name
  }
}

export const canShowStages = (demand) => {
  return _includes(["OSM", "SOM"], demand.system)
}

export const objectConstructor = (description, value) => ({
  description,
  value
})



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/incident-manager-helpers.js